//----------------------------
// is characteristics changed
//----------------------------
export default function isCharacteristicsChanged(original, now) {
  // console.log("----------------------------")
  // console.log("IN isCharacteristicsChanged")
  // console.log("----------------------------")
  // console.log("ORIGINAL...")
  // window.displayPairs(original)
  // console.log("----------------------------")
  // console.log("NOW...")
  // window.displayPairs(now)
  // console.log("----------------------------")
  // console.log("original.str_cur = " + original.str_cur)
  // console.log("now.str_cur = " + now.str_cur)
  // console.log("----------------------------")
  if (
    original.str != now.str ||
    original.str_min != now.str_min ||
    original.str_max != now.str_max ||
    original.str_dice_roll != now.str_dice_roll ||
    original.con != now.con ||
    original.con_min != now.con_min ||
    original.con_max != now.con_max ||
    original.con_dice_roll != now.con_dice_roll ||
    original.dex != now.dex ||
    original.dex_min != now.dex_min ||
    original.dex_max != now.dex_max ||
    original.dex_dice_roll != now.dex_dice_roll ||
    original.siz != now.siz ||
    original.siz_min != now.siz_min ||
    original.siz_max != now.siz_max ||
    original.siz_dice_roll != now.siz_dice_roll ||
    original.int != now.int ||
    original.int_min != now.int_min ||
    original.int_max != now.int_max ||
    original.int_dice_roll != now.int_dice_roll ||
    original.pow != now.pow ||
    original.pow_min != now.pow_min ||
    original.pow_max != now.pow_max ||
    original.pow_dice_roll != now.pow_dice_roll ||
    original.cha != now.cha ||
    original.cha_min != now.cha_min ||
    original.cha_max != now.cha_max ||
    original.cha_dice_roll != now.cha_dice_roll
  ) {
    return true
  } else {
    return false
  }
}
